export enum MaterialDamage {
  yes = 'Yes',
  no = 'No',
}
